import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { Product } from '../product';

export interface ProductsModel extends BaseFieldModel {
  defaultValue: string[] | undefined;
  products: Product[];
  type: FieldType.Products;
}
export class Products extends BaseField implements ProductsModel {
  public defaultValue: string[] | undefined;
  public products: Product[] = [];
  public type: FieldType.Products = FieldType.Products;

  constructor(cultures: string[]) {
    super(FieldType.Products, cultures);
  }
}
